import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { statusColors } from '@functions/status'

import useOrderItemTask from '@hooks/useOrderItemTask'

import type { OrderItemTaskModel } from '@models/types'

const OrderItemTask = (props: { orderItemTask: OrderItemTaskModel }) => {
  const { orderItemTask } = props

  const orderItemTaskPayload = useOrderItemTask(orderItemTask)
  const {
    callbacks: { createOrEditOrderItemTask },
    orderItem,
    orderItemTask: { due_date },
    status,
    orderItemTaskType,
  } = orderItemTaskPayload

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditOrderItemTask()}
      // @ts-expect-error TS2339
      secondaryText={orderItem.title}
      // @ts-expect-error TS2339
      title={orderItemTaskType.title}
    >
      <Box alignItems="flex-end" flexDirection="column">
        {/*
         // @ts-expect-error TS7053 */}
        <Text color={statusColors[status.key]}>{status?.title}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {due_date ? `Due ${due_date}` : 'Not Set'}
        </Text>
      </Box>
    </DashboardModuleListItem>
  )
}

export default OrderItemTask
